export default __webpack_public_path__ + "static/media/share-ios.05b94768.svg";